const STORAGE_KEY = 'lookout-last-visited-workspace';

/** Workspace id the user last opened, or null if none/unavailable. */
export function getLastWorkspaceId(): string | null {
  if (typeof window === 'undefined') return null;
  try {
    const value = window.localStorage.getItem(STORAGE_KEY);
    return value && value.length > 0 ? value : null;
  } catch {
    return null;
  }
}

/** Remember the workspace the user just opened. */
export function setLastWorkspaceId(id: string): void {
  if (typeof window === 'undefined') return;
  try {
    window.localStorage.setItem(STORAGE_KEY, id);
  } catch {
    // Ignore storage access failures (private mode, quota) — the picker still works.
  }
}

/** Forget a stale/invalid last-visited workspace. */
export function clearLastWorkspaceId(): void {
  if (typeof window === 'undefined') return;
  try {
    window.localStorage.removeItem(STORAGE_KEY);
  } catch {
    // Ignore storage access failures.
  }
}
